import React, { useState } from "react";
import { Button, Icon, Popup, Confirm } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { useAuth } from "../../../../hooks";
import { Post } from "../../../../api";
import moment from "moment";
import "./PostItem.scss";

const postController = new Post();

export function PostItem(props) {
  const { post, onReload } = props;
  const { accessToken } = useAuth();
  const [action, setAction] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");

  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const onApproveOrRejectPost = async () => {
    try {
      if (action === "approve") {
        await postController.updatePost(accessToken, post.id, { status: 1 });
      } else if (action === "reject") {
        await postController.updatePost(accessToken, post.id, { status: 2 });
      }
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="post-item">
        <div className="post-item__info">
          <span>
            <span className="post-item__info-title">{post.title}</span>
            <span className="post-item__info-subject">
              ({post.Subject.name})
            </span>
          </span>
          <span className="post-item__info-author">
            <b>Autor:</b>{" "}
            {`${post.User.firstname} ${post.User.lastname} ${post.User.secondLastname}`}
          </span>
          <span className="post-item__info-extra">
            {post.createdAt &&
              moment.utc(post.createdAt).local().format("DD/MM/YYYY hh:mm a")}
            {" • "}
            {`${post.Answers?.length} respuestas`}
          </span>
        </div>
        <div className="post-item__actions">
          <Popup
            content="Ver publicación"
            trigger={
              <Button
                icon
                color="blue"
                as={Link}
                to={`/admin/post/${post.id}`}
              >
                <Icon name="eye" />
              </Button>
            }
          />
          {post.status == 0 && (
            <>
              <Popup
                content="Aprobar publicación"
                trigger={
                  <Button
                    icon
                    color="green"
                    onClick={() => {
                      setAction("approve");
                      setConfirmMessage(
                        "¿Estás seguro que deseas aprobar la publicación?"
                      );
                      onOpenCloseConfirm();
                    }}
                  >
                    <Icon name="check" />
                  </Button>
                }
              />
              <Popup
                content="Rechazar publicación"
                trigger={
                  <Button
                    icon
                    color="red"
                    onClick={() => {
                      setAction("reject");
                      setConfirmMessage(
                        "¿Estás seguro que deseas rechazar la publicación?"
                      );
                      onOpenCloseConfirm();
                    }}
                  >
                    <Icon name="ban" />
                  </Button>
                }
              />
            </>
          )}
        </div>
      </div>
      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onApproveOrRejectPost}
        content={confirmMessage}
        size="mini"
      />
    </>
  );
}
